/*
 * {description}
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2021 Gallagher Bassett Services, Inc.
 *
 */

import {
  Directive,
  HostListener
} from '@angular/core';

@Directive ( {
    selector: '[reporterDateFormat]',
    standalone: false
} )
export class DateFormatDirective {

  @HostListener ( 'keyup', [ '$event' ] )
  public onKeyup ( event: KeyboardEvent ): void {
    const element = event.target as HTMLInputElement;
    const value = element.value;

    let formatted = value.replace ( /\D/g, '' )
      .substr ( 0, 8 );

    if ( formatted.length > 2 && formatted.length <= 4 ) {
      formatted = formatted.replace ( /^(\d{0,2})(\d{0,2})/, '$1/$2' );
    } else if ( formatted.length > 4 ) {
      formatted = formatted.replace ( /^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1/$2/$3' );
    }
    element.value = formatted;
  }

}
